import {
  FontWeight, getTypography, ThemedFunctor, TypographyName,
} from '@doveit/bricks';
import { css, keyframes } from 'styled-components';

const fadeInWithTranslation = keyframes`
  from {
    opacity: 0;
    transform: translateY(1rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    filter: grayScale(100);
  }
  to {
    opacity: 1;
    filter: grayScale(0);
  }
`;

export const basic: ThemedFunctor = ({ theme, $isSkeleton }) => css`
  background: ${theme.color.background.neutral.default.lowest};
  padding: ${theme.remSize[150]} ${theme.remSize[100]};
  border: 1px solid ${theme.color.border.neutral.default.high};
  border-radius: ${theme.remRounding['2XS']};
  animation: ${$isSkeleton ? fadeInWithTranslation : fadeIn} .5s ease-in-out;
`;

export const header: ThemedFunctor = ({ theme }) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.remSize[150]};
`;

export const title: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.HEADING_4, { fontWeight: FontWeight.LIGHT })}
  display: flex;
  align-items: center;
  gap: ${theme.remSize[100]};
  flex-grow: 1;

  > *:first-child {
    flex-shrink: 0;
    line-height: 0;
  }
`;

export const titleText: ThemedFunctor = ({ theme }) => css`
  display: flex;
  align-items: center;
  gap: ${theme.remSize[75]};
  flex-grow: 1;
`;

export const details: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.BODY_SMALL, { fontWeight: FontWeight.LIGHT })}
  display: flex;
  align-items: center;
  gap: ${theme.remSize[100]};

  > *:first-child {
    flex-shrink: 0;
    line-height: 0;
  }
`;

export const target = () => css`
  font-weight: ${FontWeight.MEDIUM};
`;

export const popover: ThemedFunctor = () => css`
  flex-shrink: 0;
  line-height: 0;
`;

export const popoverContent: ThemedFunctor = ({ theme }) => css`
  width: 14rem;
  padding: ${theme.remSize[100]}
`;
